

import React, { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { getData, postData } from '../Services/api'
import { toast } from 'react-toastify'
import JoditEditor from 'jodit-react';
const UpdateAbout = () => {
    const config = useMemo(() => ({
        readonly: false,
        toolbar: true,
        placeholder: "", // ❌ empty string hides placeholder
        askBeforePasteHTML: false,
    }), []);
    const [values, setValues] = useState({
        heroTitle: "",
        heroDescription: "",
        storyTitle: "",
        storyContent: "",
        storyImage: null,
        features: [{ title: "", description: "", icon: null }],
        team: [{ name: "", role: "", image: null }],
        ourValues: [{ title: "", text: "" }]
    })

    const [loading, setLoading] = useState(false)

    const handleTeamChange = (index, field, value) => {
        const updated = [...values.team];
        updated[index][field] = value;
        setValues({ ...values, team: updated });
    };

    const addTeamMember = () => {
        setValues({ ...values, team: [...values.team, { name: "", role: "", image: null }] });
    };

    const removeTeamMember = (index) => {
        const updated = [...values.team];
        updated.splice(index, 1);
        setValues({ ...values, team: updated });
    };

    const handleTeamImageChange = (index, file) => {
        const updated = [...values.team];
        updated[index].image = file;
        setValues({ ...values, team: updated });
    };
    const handleFeatureChange = (index, field, value) => {
        const updated = [...values.features];
        updated[index][field] = value;
        setValues({ ...values, features: updated });
    };
    const handleFeatureImageChange = (index, file) => {
        const updated = [...values.features];
        updated[index].icon = file;
        setValues({ ...values, features: updated });
    };
    const addFeature = () => {
        setValues({ ...values, features: [...values.features, { title: "", description: "", icon: null }] });
    };
    const removeFeature = (index) => {
        const updated = [...values.features];
        updated.splice(index, 1);
        setValues({ ...values, features: updated });
    };
    const removeStoryImage = () => {
        setValues({ ...values, storyImage: null });
    };

    const handleOurValuesChange = (index, field, value) => {
        const updated = [...values.ourValues];
        updated[index][field] = value;
        setValues({ ...values, ourValues: updated });
    };

    const addOurValues = () => {
        setValues({ ...values, ourValues: [...values.ourValues, { title: "", text: "" }] });
    };

    const removeOurValues = (index) => {
        const updated = [...values.ourValues];
        updated.splice(index, 1);
        setValues({ ...values, ourValues: updated });
    };
    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (name === "storyImage" && files?.[0]) {
            setValues({ ...values, storyImage: files[0] });
        } else {
            setValues({ ...values, [name]: value });
        }
    };

    const fetchAbout = async () => {
        try {
            const res = await getData('/about');
            if (res.status) {
                const data = res.data || {};
                setValues({
                    heroTitle: data.heroTitle || "",
                    heroDescription: data.heroDescription || "",
                    storyTitle: data.storyTitle || "",
                    storyContent: data.storyContent || "",
                    storyImage: data.storyImage || null,
                    features: data.features?.length ? data.features : [{ title: "", description: "", icon: null }],
                    team: data.team?.length ? data.team : [{ name: "", role: "", image: null }],
                    ourValues: data.ourValues?.length ? data.ourValues : [{ title: "", text: "" }]
                });
            }
        } catch (error) {
            console.log("error fetch footer", error);
        }
    }


    useEffect(() => {
        fetchAbout();
    }, []);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const formData = new FormData();

            // Story image
            if (values.storyImage instanceof File) {
                formData.append("storyImage", values.storyImage);
            }

            // Feature images
            values.features.forEach(f => {
                if (f.icon instanceof File) {
                    formData.append("featureImages", f.icon);
                }
            });

            // Team images
            values.team.forEach(t => {
                if (t.image instanceof File) {
                    formData.append("teamImages", t.image);
                }
            });

            // JSON data
            formData.append("data", JSON.stringify(values));

            const res = await postData('/about', formData);

            if (res.status) {
                toast.success(res.message || "About page updated successfully!");
                fetchAbout();
            }
        } catch (error) {
            console.log("Error updating about", error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Update About Page
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Update About Page</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Update About Page</h5>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Hero Title</label>
                                                    <input type="text"
                                                        name="heroTitle"
                                                        value={values.heroTitle}
                                                        onChange={handleChange}
                                                        className='form-control'
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Hero Description</label>
                                                    <textarea
                                                        name="heroDescription"
                                                        value={values.heroDescription}
                                                        onChange={handleChange}
                                                        className='form-control'
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Story Title</label>
                                                    <input type="text"
                                                        name="storyTitle"
                                                        value={values.storyTitle}
                                                        onChange={handleChange}
                                                        className='form-control'
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Story Content</label>
                                                    <JoditEditor
                                                        config={config}
                                                        value={values.storyContent}
                                                        onBlur={(newContent) =>
                                                            setValues(prev => ({
                                                                ...prev,
                                                                storyContent: newContent
                                                            }))
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 form-group">
                                                <label>Story Image</label>
                                                <input type="file" name="storyImage" onChange={handleChange} className="form-control" />
                                                {values.storyImage && (
                                                    <div style={{ position: "relative", display: "inline-block", marginTop: 5 }}>
                                                        <img
                                                            src={values.storyImage instanceof File ? URL.createObjectURL(values.storyImage) : values.storyImage}
                                                            alt="story"
                                                            style={{ width: 100, height: 100, objectFit: "cover", borderRadius: 4 }}
                                                        />
                                                        <button type="button" onClick={removeStoryImage} style={{
                                                            position: "absolute", top: -8, right: -8, background: "red", color: "#fff", border: "none", borderRadius: "50%", width: 24, height: 24
                                                        }}>×</button>
                                                    </div>
                                                )}
                                            </div>
                                            <h3>Features</h3>
                                            {values.features?.map((feature, index) => (
                                                <div className='row' key={index}>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label className="form-label">Title</label>
                                                            <input
                                                                placeholder="Title"
                                                                value={feature.title}
                                                                className='form-control'
                                                                onChange={(e) =>
                                                                    handleFeatureChange(index, "title", e.target.value)
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label className="form-label">Description</label>
                                                            <textarea
                                                                placeholder="Description"
                                                                className='form-control'
                                                                value={feature.description}
                                                                onChange={(e) =>
                                                                    handleFeatureChange(index, "description", e.target.value)
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label className="form-label">Icon</label>
                                                            <input
                                                                type="file"
                                                                className='form-control'
                                                                onChange={(e) =>
                                                                    handleFeatureChange(index, "icon", e.target.files[0])
                                                                }
                                                            />
                                                            {feature.icon && (
                                                                <div style={{ position: "relative", display: "inline-block", marginTop: 5 }}>
                                                                    <img
                                                                        src={feature.icon instanceof File ? URL.createObjectURL(feature.icon) : feature.icon}
                                                                        alt="feature"
                                                                        style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 4 }}
                                                                    />
                                                                    <button type="button" onClick={() => handleFeatureImageChange(index, null)} style={{
                                                                        position: "absolute", top: -6, right: -6, background: "red", color: "#fff", border: "none", borderRadius: "50%", width: 20, height: 20
                                                                    }}>×</button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-1 mt-1">
                                                        <div className='d-flex justify-content-between mt-4'>
                                                            {index > 0 && (
                                                                <button type="button" className="btn btn-danger mx-2" onClick={() => removeFeature(index)}>–</button>
                                                            )}
                                                            <button type="button" className='btn btn-success' onClick={addFeature}>
                                                                <i className='fas fa-plus'></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}

                                            <h5>Team</h5>
                                            {values.team?.map((member, index) => (
                                                <div className='row' key={index}>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label className="form-label">Name</label>
                                                            <input
                                                                placeholder="Title"
                                                                value={member.name}
                                                                className='form-control'
                                                                onChange={(e) =>
                                                                    handleTeamChange(index, "name", e.target.value)
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label className="form-label">Role</label>
                                                            <input
                                                                placeholder="Role"
                                                                className='form-control'
                                                                value={member.role}
                                                                onChange={(e) =>
                                                                    handleTeamChange(index, "role", e.target.value)
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label className="form-label">image</label>
                                                            <input
                                                                type="file"
                                                                className='form-control'
                                                                onChange={(e) =>
                                                                    handleTeamChange(index, "image", e.target.files[0])
                                                                }
                                                            />
                                                            {member.image && (
                                                                <div style={{ position: "relative", display: "inline-block", marginTop: 5 }}>
                                                                    <img
                                                                        src={member.image instanceof File ? URL.createObjectURL(member.image) : member.image}
                                                                        alt="team"
                                                                        style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 4 }}
                                                                    />
                                                                    <button type="button" onClick={() => handleTeamImageChange(index, null)} style={{
                                                                        position: "absolute", top: -6, right: -6, background: "red", color: "#fff", border: "none", borderRadius: "50%", width: 20, height: 20
                                                                    }}>×</button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-md-1 mt-1">
                                                        <div className='d-flex justify-content-between mt-4'>
                                                            {index > 0 && (
                                                                <button type="button" className="btn btn-danger mx-2" onClick={() => removeTeamMember(index)}>–</button>
                                                            )}
                                                            <button type="button" className='btn btn-success' onClick={addTeamMember}>
                                                                <i className='fas fa-plus'></i>
                                                            </button>
                                                        </div>
                                                    </div>

                                                </div>
                                            ))}
                                            <h3>Our Values</h3>
                                            {values.ourValues?.map((our, index) => (
                                                <div className='row' key={index}>
                                                    <div className="col-md-5">
                                                        <div className="form-group">
                                                            <label className="form-label">Title</label>
                                                            <input
                                                                placeholder="Title"
                                                                value={our.title}
                                                                className='form-control'
                                                                onChange={(e) =>
                                                                    handleOurValuesChange(index, "title", e.target.value)
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <div className="form-group">
                                                            <label className="form-label">Text</label>
                                                            <textarea
                                                                placeholder="Text"
                                                                className='form-control'
                                                                value={our.text}
                                                                onChange={(e) =>
                                                                    handleOurValuesChange(index, "text", e.target.value)
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 mt-1">
                                                        <div className='d-flex justify-content-between mt-4'>
                                                            {index > 0 && (
                                                                <button type="button" className="btn btn-danger mx-2" onClick={() => removeOurValues(index)}>–</button>
                                                            )}
                                                            <button type="button" className='btn btn-primary' onClick={addOurValues}>
                                                                <i className='fas fa-plus'></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            <div className="text-end btn-page mb-0 mt-4">
                                                <button className="btn btn-success" type="submit" disabled={loading}>
                                                    {loading ? "Updating..." : "Update About"}
                                                </button>
                                            </div>
                                        </div>
                                    </form >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UpdateAbout